define.alias("ember-math-helpers/helpers/abs", "media/helpers/abs");